import apiFetch from '../apiFetch'

export default function (idOperario, token) {
  return apiFetch({endPoint: `Operario/getOperario?idOperario=${idOperario}`, method: 'GET', body: null, token: token})
}
